import { render } from "./TableIterator.vue?vue&type=template&id=0ba4ce22&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform"
import script from "./TableIterator.vue?vue&type=script&lang=js"
export * from "./TableIterator.vue?vue&type=script&lang=js"

import "./TableIterator.vue?vue&type=style&index=0&id=0ba4ce22&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__